import { render, staticRenderFns } from "./groupNavBar.vue?vue&type=template&id=0bb31364&scoped=true&"
import script from "./groupNavBar.vue?vue&type=script&lang=js&"
export * from "./groupNavBar.vue?vue&type=script&lang=js&"
import style0 from "./groupNavBar.vue?vue&type=style&index=0&id=0bb31364&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb31364",
  null
  
)

export default component.exports